import { render, staticRenderFns } from "./ownerDetailAccessControl.vue?vue&type=template&id=bf94ecd8&scoped=true"
import script from "./ownerDetailAccessControl.vue?vue&type=script&lang=js"
export * from "./ownerDetailAccessControl.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailAccessControl.vue?vue&type=style&index=0&id=bf94ecd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf94ecd8",
  null
  
)

export default component.exports